"use client";

import Magnetic from "@/components/ui/Magnetic";
import RotatingCTA from "@/components/ui/RotatingCTA";
import { trackClarityEvent } from "@/lib/clarity-event";
import { MoveRight } from "lucide-react";
import Link from "next/link";

export default function CTA() {
    return (
        <section className="py-32 bg-primary text-white">
            <div className="max-w-7xl mx-auto px-4 sm:px-6 lg:px-8 text-center">
                <h2 className="text-5xl md:text-7xl font-bold mb-8 tracking-tighter">Ready to build something <br />extraordinary?</h2>
                <p className="text-xl md:text-2xl mb-12 max-w-2xl mx-auto font-medium">
                    From MVP to massive scale, we have the expertise to get you there. Let&apos;s turn your vision into reality.
                </p>
                <div className="flex flex-col sm:flex-row items-center justify-center gap-6">
                    <Magnetic strength={0.2}>
                        <Link
                            href="/contact"
                            className="px-8 py-4 bg-white text-black text-lg font-bold uppercase tracking-wider hover:bg-gray-100 border-2 border-white transition-all shadow-lg hover:shadow-xl hover:-translate-y-1 flex items-center space-x-2 rounded-full"
                            onClick={() => trackClarityEvent('lead_click_start_project')}
                        >
                            <RotatingCTA />
                            <MoveRight className="h-5 w-5" />
                        </Link>
                    </Magnetic>
                    <Magnetic strength={0.1}>
                        <Link href="/services" className="px-8 py-4 bg-transparent text-white text-lg font-bold uppercase tracking-wider border-2 border-white hover:bg-white/10 transition-all rounded-full backdrop-blur-sm">
                            View Services
                        </Link>
                    </Magnetic>
                </div>
            </div>
        </section>
    );
}
